import React from "react";
import BaseField from "./BaseField";

export default function DocumentNumberField({
  field,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  return (
    <BaseField
      field={field}
      value={null}
      setValue={() => {}}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      <div
        className="p-4 text-center rounded-xl border-2 border-orange-300 shadow-inner bg-gradient-to-b from-white to-orange-50 dark:from-gray-700 dark:to-gray-600"
      >
        <p className="font-mono text-gray-800 dark:text-gray-100 text-lg tracking-widest">
          {field.config?.prefix ?? ""}
          {String(field.config?.nextNumber ?? 1).padStart(
            Math.max(1, field.config?.pad ?? 1),
            "0"
          )}
        </p>
        <p className="text-[11px] text-gray-400 mt-1 italic">
          Document Number
        </p>
      </div>
    </BaseField>
  );
}
